import {gsap, Quart} from 'gsap/all';
import utils from '@/_modules/utils';
import $transitions from '@/_modules/Transitions';
import gnav from '@/_modules/common/gnav';

export default class Sub {
  constructor() {
    this.getHeight100();
    this.isInit = false;
    this.isGLReady = false;
    this.winH = 0;
    this.conH = 0;
  }

  start() {
    $transitions.hideSub();
    gnav.start();
  }

  init() {
    this.resizeObserver = new ResizeObserver(this.resize.bind(this));
    this.resizeObserver.observe(document.getElementById('c-container'));

    gnav.once({isTop:false});
    //footer.once();

    gEvent.on('OPEN_GNAV', this.openNav.bind(this));
    gEvent.on('CLOSE_GNAV', this.closeNav.bind(this));

    this.initPage();

    requestAnimationFrame(this.start.bind(this));
  }

  openNav() {
    //window.$scroll.stop();
  }

  closeNav() {
    //window.$scroll.start();
  }

  leave({current, next}) {
    // リセット
    //this.resetPage(current.namespace);
  }

  initPage() {
    const namespace = 'common';

    // rootにclass追加
    gAMBR.rootHTML.classList.add(`is-page-common`);

    gnav.init(namespace);
  }

  getHeight100() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  resize(entries) {
    //this.getHeight100();
    this.winH = window.innerHeight;
    this.conH = document.getElementById('c-container').getBoundingClientRect().height;
  }
}
